import { MetaInfo } from "@/components/meta-info"
import { api } from "@/lib/api"
import Plans from "../plans/plans"
import { PLAN_PRICES } from "../plans/prices"
import { SettingsHeader } from "../settings-header"

export function PlansPricingPage() {
	const { data: activePlan } = api.workspace.activePlan.useQuery()

	return (
		<>
			<MetaInfo title="All plans" />

			<SettingsHeader
				title="All plans"
				subtitle="Compare every plan and switch whenever you need to."
			/>

			<Plans
				activePlan={activePlan ?? "free"}
				isPublic={false}
				prices={PLAN_PRICES}
			/>
		</>
	)
}
